import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { AttendanceComponent } from './components/attendance/attendance.component';
// import { LeaveComponent } from './components/attendance-review/attendance-review.component';
// import { UnmatchedAttendanceComponent } from './components/unmatched-attendance/unmatched-attendance.component';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';


@Component({
  selector: 'app-attendance-management',
  standalone: true,
  imports: [
    LayoutComponent,
    CommonModule,
    MatTabGroup,
    MatTabsModule,
    AttendanceComponent,
    // LeaveComponent,
    // UnmatchedAttendanceComponent,
    // PermissionDirective
  ],
  templateUrl: './attendance-management.component.html',
  styleUrl: './attendance-management.component.scss',

})
export class AttendanceManagementComponent {
  @ViewChild('attendanceComponent') attendanceComponent!: AttendanceComponent;
  // @ViewChild('managementComponent') managementComponent!: LeaveComponent;
  // @ViewChild('unmatchedAttendanceComponent') unmatchedAttendanceComponent!: UnmatchedAttendanceComponent;
  // Permission = Permission;
  
  constructor(
  ) {
    
  }

  ngOnInit() {
  }


  onTabChange(index: any) {
    console.log(index, 'eventtttt');
    
    if (index === 0) {
      this.attendanceComponent.fetchAttendance(); 
    }
    
  }

}